import slice from './Authorization.slice';

const { reducer } = slice;
export { reducer as AuthorizationReducer };
export { saga as AuthorizationSaga } from './Authorization.sagas';